export default "__VITE_ASSET__C_dX7yay__"